const china = {
  hello: '你好',
  chooseStatus: '已选中',
  timeTitle: '活动结束倒计时',
  timeTitle1: '活动已结束',
  timeTitle2: '活动未开始',
  days: '天',
  hour: '时',
  minute: '分',
  second: '秒',
  allNumsName: '总票数',
  playnumsName: '候选数',
  votenumsName: '访问量',
  voteStart: '投票开始',
  voteEnd: '投票结束',
  voteRule: '投票规则',
  activeRule: '活动规则',
  searchTip: '请输入选手编号或名称',
  searchBtn: '搜索',
  vote: '投票',
  playerNo: '号',
  introduce: '介绍',
  activeIntroduce: '活动介绍',
  rank: '排行',
  rankName: '排名',
  rankName2: '排行榜',
  voteNums: '票数',
  voteUnit: '票',
  infoBtn: '详情',
  loadding: '加载中···',
  noDesc: '暂无简介',
  lastNext: '距上一名',
  numbers: '票数',
  helpme: '为我拉票',
  report: '举报/投诉',
  first: '第一名',
  now: '当前',
  change: '切换语言',
  share1: '请点击右上角',
  share2: '将它发送给指定朋友',
  share3: '或分享到朋友圈',
  rules: '每个微信号每天可以投5票，不可投票同一选手。',
  all: '全部',
}
export default china